import React, { FC, useEffect } from "react";
import { Paper, CircularProgress } from "@material-ui/core";
import globalsCss from "../../common/styles/globals.css";
/** @jsx jsx */
import { jsx } from "@emotion/react";
import * as queryString from "query-string";
import { useDispatch } from "react-redux";
import { redirectUri } from "@/common/services/saml";
import actionCreators from "@/store/Auth/actionCreators";
import { RouteComponentProps } from "react-router";

const Authorise: FC<RouteComponentProps> = ({ history }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const validate = async () => {
            const queryParams = queryString.parse(location.search);
            const stateSaved = localStorage.getItem("lsha_auth_state");
            const codeVerifierSaved = localStorage.getItem("lsha_auth_code_verifier");

            if (
                !queryParams?.code ||
                !queryParams?.state ||
                queryParams?.state !== stateSaved ||
                !codeVerifierSaved
            ) {
                localStorage.removeItem("lsha_auth_state");
                localStorage.removeItem("lsha_auth_code_verifier");
                dispatch(actionCreators.errorResponse.create("SAML verification error"));
                history.push("/auth/error");
            } else {
                dispatch(
                    actionCreators.samlValidate.create(
                        JSON.stringify({
                            code: queryParams?.code,
                            codeVerifier: codeVerifierSaved,
                            redirectUri: redirectUri,
                            state: queryParams?.state,
                        })
                    )
                );
            }
        };

        validate();
    }, []);

    return (
        <Paper elevation={1}>
            <div css={globalsCss.inner}>
                <CircularProgress color="inherit" size={20} thickness={2} />
            </div>
        </Paper>
    );
};

export default Authorise;
